// extracted by css-extract-rspack-plugin
export default {"toolbarWrapper":"toolbar-wrapper_EIcwv","spinWrapper":"spin-wrapper_HJvNK"};